import type { ChatymeInitOptions } from '../types/chatymeHost';

export class ChatymeEmbedHelper {
  private cancelled = false;
  private script: HTMLScriptElement | null = null;
  private messageHandler: ((event: MessageEvent) => void) | null = null;

  load(options: ChatymeInitOptions, onMessage?: (event: MessageEvent) => void): void {
    this.destroy();

    this.cancelled = false;
    this.script = document.createElement('script');
    this.script.src = `/chatyme.js?v=${Date.now()}`;

    this.messageHandler = (event: MessageEvent) => {
      onMessage?.(event);
    };

    this.script.onload = () => {
      if (this.cancelled) {
        return;
      }
      window.Chatyme?.init(options);
    };

    document.body.appendChild(this.script);
    window.addEventListener('message', this.messageHandler);
  }

  destroy(): void {
    this.cancelled = true;

    if (this.messageHandler) {
      window.removeEventListener('message', this.messageHandler);
      this.messageHandler = null;
    }

    window.Chatyme?.destroy();
    this.script?.remove();
    this.script = null;
  }
}
